import script from "./data-valid.vue?vue&type=script&lang=ts&setup=true"
export * from "./data-valid.vue?vue&type=script&lang=ts&setup=true"

import "./data-valid.vue?vue&type=style&index=0&id=12542815&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12542815"]])

export default __exports__